export const PAGE_ICONS = [
  { id: 'icon-th' },
  { id: 'icon-mail' },
  { id: 'icon-info' },
];
